'use client'

import { useState, useEffect } from 'react'
import Logo from './Logo'
import Link from 'next/link'
import { Button } from '@/components/ui/button'
import { Menu, X } from 'lucide-react'

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <header className={`fixed left-0 right-0 top-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm' : 'bg-transparent'
    }`}>
      <div className="container mx-auto flex items-center justify-between px-6 py-4">
        <Logo width={60} height={60} />
        <nav className="hidden space-x-8 md:flex">
          <Link href="/about" className="font-bold text-navy-900 hover:text-rose-300">About</Link>
          <Link href="/services" className="font-bold text-navy-900 hover:text-rose-300">Services</Link>
          <Link href="/faq" className="font-bold text-navy-900 hover:text-rose-300">FAQ</Link>
        </nav>
        <div className="flex items-center gap-4">
          <Button asChild className="bg-rose-300 text-navy-900 hover:bg-rose-200">
            <Link href="/booking">Book Now</Link>
          </Button>
          <button
            className="md:hidden"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle navigation menu"
          >
            <Menu className="h-6 w-6 text-navy-900" />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`fixed right-0 top-0 h-screen w-64 transform bg-white p-6 shadow-lg transition-transform duration-300 ease-in-out md:hidden ${
          isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <button
          onClick={() => setIsMobileMenuOpen(false)}
          className="absolute right-4 top-4 inline-flex h-8 w-8 items-center justify-center rounded-lg hover:bg-rose-100"
          aria-label="Close menu"
        >
          <X className="h-6 w-6 text-navy-900" />
        </button>
        <nav className="mt-16 flex flex-col gap-6">
          <Link
            href="/about"
            className="text-lg font-bold text-navy-900 hover:text-rose-300"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            About
          </Link>
          <Link
            href="/services"
            className="text-lg font-bold text-navy-900 hover:text-rose-300"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Services
          </Link>
          <Link
            href="/faq"
            className="text-lg font-bold text-navy-900 hover:text-rose-300"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            FAQ
          </Link>
          <Link
            href="/booking"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            <Button className="w-full bg-rose-300 text-navy-900 hover:bg-rose-200">
              Book Now
            </Button>
          </Link>
        </nav>
      </div>
    </header>
  )
}
